import * as React from "react";
import { ISelectableItem } from "./selectableItemConverters";
import { ResourceProvider } from "../../resourceProvider";

export interface SelectableItemComponentProps extends ISelectableItem {
	onClick: () => void;
	isDisabled: boolean;
	itemClassName: string;
	colStyle?: string;
	itemTitleClassName?: string;
}

export class SelectableItemComponent extends React.Component<SelectableItemComponentProps> {
	constructor(props: SelectableItemComponentProps) {
		super(props);

		this.selectItem = this.selectItem.bind(this);
	}

	private selectItem(): void {
		if (!this.props.isDisabled) {
			return this.props.onClick();
		}
		return;
	}

	render() {
		const selectableImageUrl =
			this.props.imageUrl ?
				{
					backgroundImage: `url("${this.props.imageUrl}")`
				}
				:
				{}

		var imageClassName = 'selectable-image';

		if (this.props.imageClassName) {
			imageClassName += ' ' + this.props.imageClassName;
		}

		return <div className={`${this.props.colStyle} selectable-item ${this.props.itemClassName} ${this.props.selected ? " selected" : ""}` + (this.props.isDisabled ? " disabled" : "")} onClick={this.selectItem}>
			<div className="check"></div>
			<div className={imageClassName} style={selectableImageUrl}>
				{this.props.isDisabled &&
					<span className="disabled-text">{ResourceProvider.getText("WizardPage.NotAvailableForSelectedCar.Label")}</span>
				}
			</div>
			<div className={`title ${this.props.itemTitleClassName ? this.props.itemTitleClassName : ""}`}>{this.props.title}</div>
			<div className="description">{this.props.description}</div>
		</div>;
	}
}

export default SelectableItemComponent;